import ApiService from "@/services/Api"
import { DetailedWABAChannelMessageTemplate, WABAChannelMessageTemplate, WABATemplateVariableMapping } from "@/@integrations/WABA/protocols/wabaChannelMessageTemplate"
import { TemplatesFiltersData, TemplatesWhereData } from "@/pages/Admin/Templates"
import { ManageTemplate } from "@/pages/Admin/Templates/ManageTemplateForm"

class WABAChannelMessageTemplateService {
	async syncAllTemplates (channelId?: number): Promise<void> {
		await ApiService.get(`/waba/channel/${channelId}/message/template/sync-all`)
	}

	async syncOneTemplate (integrationId?: string, channelId?: number): Promise<void> {
		await ApiService.get(`/waba/channel/${channelId}/message/template/${integrationId}/sync`)
	}

	async retrieveAllByInboxChannelId (inboxChannelId?: number): Promise<WABAChannelMessageTemplate[]> {
		const response = await ApiService.get<{ wabaChannelMessageTemplates: WABAChannelMessageTemplate[] }>(`/waba/channel/${inboxChannelId}/message/template`)

		return response.data.wabaChannelMessageTemplates
	}

	async retrieveAllDetailedByInboxChannelId (params: TemplatesWhereData & TemplatesFiltersData, inboxChannelId?: number): Promise<{ rows: DetailedWABAChannelMessageTemplate[], count: number }> {
		const response = await ApiService.get(`/waba/channel/${inboxChannelId}/message/template/detailed`, {
			params
		})

		return response.data
	}

	async createMessageTemplate (data: ManageTemplate, inboxChannelId?: number): Promise<void> {
		await ApiService.post(`/waba/channel/${inboxChannelId}/message/template`, { ...data })
	}

	async editMessageTemplate (data: ManageTemplate, inboxChannelId?: number): Promise<void> {
		await ApiService.put(`/waba/channel/${inboxChannelId}/message/template`, { ...data })
	}

	async retrieveOneTemplateById (wabaChannelMessageTemplateId: number, inboxChannelId?: number): Promise<WABAChannelMessageTemplate> {
		const response = await ApiService.get<WABAChannelMessageTemplate>(`/waba/channel/${inboxChannelId}/message/single-template/${wabaChannelMessageTemplateId}`)

		return response.data
	}

	async updateVariableMapping (templateId: number, inboxChannelId: number, variableMapping: WABATemplateVariableMapping): Promise<void> {
		await ApiService.patch(`/waba/channel/${inboxChannelId}/message/template/${templateId}/variable-mapping`, { variableMapping })
	}

	async markTemplateSource (inboxChannelId: number, name: string, source: string): Promise<void> {
		await ApiService.patch(`/waba/channel/${inboxChannelId}/message/template/${name}/source`, { source })
	}
}

export default new WABAChannelMessageTemplateService()
